import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { ERROR_404_CLASSNAME } from '@e-socna/printer-contract';

import { PATH_HOME } from '../../app/constants/paths.constant';
import { buildDocumentTitle } from '../../utils/document-title.util';

export const NotFoundPage = () => (
  <>
    <Helmet>
      <title>{buildDocumentTitle('Ressource inexistante')}</title>
    </Helmet>
    <Box sx={{ textAlign: 'center' }}>
      <Typography
        // eslint-disable-next-line react/forbid-component-props
        className={ERROR_404_CLASSNAME}
        component="h1"
        sx={{ pt: 4, pb: 4 }}
        variant="h4"
      >
        Ressource inexistante
      </Typography>
      <Button component={Link} size="large" to={PATH_HOME} variant="contained">
        Accueil
      </Button>
    </Box>
  </>
);
